'use strict';

var maxRepetitions = 60;
var repetitionCount = 0;
var isWindowStyleAppended = false;

var gorgiasChatInterval = window.setInterval(function () {
  var container = document.querySelector('#gorgias-chat-container');
  if (!container) return;

  var chatButtonContainer = container.querySelector('#chat-button');
  var chatWindowContainer = container.querySelector('#chat-window');

  if (!chatButtonContainer || !chatWindowContainer) return;

  var chatButtonHead = chatButtonContainer.contentWindow.document.querySelector('head');
  var chatWindowHead = chatWindowContainer.contentWindow.document.querySelector('head');

  if (chatButtonHead && chatButtonHead.children.length && chatWindowHead && chatWindowHead.children.length && !isWindowStyleAppended) {
    var windowStyles = document.createElement('style');

    // the custom CSS for the chat window
    windowStyles.textContent = '\n      .close-handle {\n        width: 3.125rem;\n        height: 100%;\n        background-color: #60C7FF;\n      }\n    ';

    chatWindowHead.appendChild(windowStyles);
    isWindowStyleAppended = true;
  }

  if (++repetitionCount == maxRepetitions) {
    window.clearInterval(gorgiasChatInterval);
  }
}, 100);